import { MarkdownUploadWizard } from "./markdown-upload-wizard"

export function MarkdownUploadField() {
	return (
		<>
			<div>
				<header className="space-y-1 text-sm">
					<div className="text-base font-medium">File upload</div>
					<div className="mb-6 text-secondary">
						Import Docs from Markdown files
					</div>
				</header>
				<div className="mt-4 overflow-hidden">
					<MarkdownUploadWizard />
				</div>
			</div>
		</>
	)
}
